import React from 'react'
import PropTypes from 'prop-types'
import {Box, Heading} from '@salesforce/retail-react-app/app/components/shared/ui'
import ProductCarousel from '../../../../app/components/product-carousel'
import {pdProductCarousalStyles} from '../../../theme/components/project/pdpage-product-recommendation-styles'
/**
 * Einstein Carousel
 * @param {object} props
 * @returns {React.ReactElement} - EinsteinCarousel component.
 */
export const EinsteinCarousel = ({textHeadline, recommender, count}) => {
    return (
        <Box sx={pdProductCarousalStyles} className="carousel-wrapper">
            <Box
                data-test-id="einstein-carousal"
                position="relative"
                pb={6}
                className="pd-product-carousal-container"
            >
                <Heading className="recommenderHeading" as={'h2'}>
                    {textHeadline ?? ''}
                </Heading>

                {/* Einstein Carousel */}
                {recommender && recommender.value && (
                    <Box className={'einsteinRecommendations'}>
                        <ProductCarousel recommender={recommender.value} count={count} />
                    </Box>
                )}
            </Box>
        </Box>
    )
}

EinsteinCarousel.propTypes = {
    textHeadline: PropTypes.string,
    displayRatings: PropTypes.bool,
    recommender: PropTypes.shape({
        value: PropTypes.string
    }),
    count: PropTypes.string
}

export default EinsteinCarousel
